import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type PaymentReceiptUseViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  detailValue?: { displayId: string; id: string } | null;
  detail: string;
  usedAtValue?: { displayId: string; id: string } | null;
  usedAt: Date | null;
  signedEditionValue: { displayId: string; id: string } | null;
};

export const PaymentReceiptUseViewForm: React.FC<PaymentReceiptUseViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      detail = "",
      usedAt = null,
      signedEditionValue,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupPaymentReceiptUseLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={detail}
                  label={langStore.PaymentReceiptUseDetailLabel}
                />
                <ShowDateTime
                  value={usedAt}
                  label={langStore.PaymentReceiptUseUsedAtLabel}
                />
                <ShowReference
                  label={langStore.PaymentReceiptUseSignedEditionLabel}
                  selectedValue={langStore.displayIdByLang(
                    signedEditionValue?.displayId
                  )}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
